
<template>
  <div
    id="new-nav-login-panel"
    class="new-nav-login-panel"
  >
    <Index />
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import Index from '@/components/index.vue';
import { useLoginStore } from '@/store';
import { isLogin } from '@common/logic';

onMounted(() => {
  // 添加登录和退出的回调函数
  const loginStore = useLoginStore();
  loginStore.updateLoginStatus(isLogin());
  window.txv?.login?.addLoginCallback(() => {
    loginStore.updateLoginStatus(true);
  });
  window.txv?.login?.addLogoutCallback(() => {
    loginStore.updateLoginStatus(false);
  });
});

</script>

<style lang="scss">
.new-nav-login-panel {
  width: 320px;
  height: 100%;
}
</style>

